var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.000244141H8C6.67392 0.000244141 5.40215 0.527028 4.46447 1.46471C3.52678 2.40239 3 3.67416 3 5.00024V8.00024H0V12.0002H3V20.0002H7V12.0002H10L11 8.00024H7V5.00024C7 4.73503 7.10536 4.48067 7.29289 4.29314C7.48043 4.1056 7.73478 4.00024 8 4.00024H11V0.000244141Z",
    fill: "#FFC794"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.8af390ad310c0af7878ac8ef8461cefc.svg";
export { ForwardRef as ReactComponent };